/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				const lockReverseAction = () => {
					let name;
					if (this.isTypeLocked()) {
						name = 'lockType';
					} else {
						name = 'unlockType';
					}
					return [{
						name: name
					}];
				};
				this.apiSpec = {
					name: 'visualization API',
					features: {
						'Dashboard.Transaction': this.transaction
					},
					events :{
						propagationInfo: {
							info: {
								supportsUndoRedo: true,
								refresh: {
									dataIfQueryChanged: true
								}
							}
						},
						actions: {
							setDataSource: {
								eventName: 'dataSource',
								getUndoActions: () => {
									const dataSource = this.getDataSource();
									return [{ params:[dataSource ? dataSource.getId(): null ] }];
								},
								isTriggerEvent: (action, undoActions, returnValue) => {
									return returnValue;
								}
							},
							setType: {
								info: {
									supportsUndoRedo: true,
									refresh: {
										all: true, // need to refresh all so that we can refresh the visView
										propertiesPane: true
									}
								},
								eventName: 'type',
								getUndoActions: (args) => {
									const actions = [];
									actions.push({
										name: 'setType',
										params:[this.getType()]
									});
									// Get the dataitem that are mappedn to slots that do not exist in the new definition
									const newDefinition = this.visDefinitions.getByType(args[0]);
									if (newDefinition) {
										const newSlots =newDefinition.getSlotList();
										const slotsToBeRemoved = this.slotsImpl.getSlotList().filter(slot => {
											return !newSlots.find(newSlot => newSlot.getId() === slot.getId());
										});

										slotsToBeRemoved.forEach(slotToBeRemoved => {
											// Use the internal getDataItemList method and include the option to ignore default slot dataitems
											// default data items don't need to be tracked in here.
											const dataItems = this.slotsImpl.getSlotImpl(slotToBeRemoved.getId()).getDataItemList(true);
											if(dataItems.length > 0){
												actions.push({
													callStack: [{
														name:'getSlots',
														params:[]
													},{
														name:'getSlot',
														params:[slotToBeRemoved.getId()]
													}],
													name: 'addDataItemsMapping',
													params:[dataItems.map(dataItem => dataItem.getId()), 0]
												});
											}
										});
									}
									return actions;
								}
							},
							lockType: {
								eventName: 'lockType',
								getUndoActions: lockReverseAction
							},
							unlockType: {
								info: {
									supportsUndoRedo: true,
									refresh: {
										all: true  // Refresh everything including the visView.. unlocking might change the visType
									}
								},
								eventName: 'unlockType',
								getUndoActions: lockReverseAction
							}
						}
					}
				};
			}
			return this.apiSpec;

		}

	}

	return APISpec;
});
